import {SalesDto} from "../../models/sales/sales-dto";
import {SalesUtils} from "./sales-utils";
import {LinkedDtoRepository} from "../../../common/repositories/linked-dto-repository";
import {SalesDataCacheVO} from "../../models/sales-cache/sales-data-cache-vo";

export class SalesWrapper {
  public sales: SalesDto[] = [];
  public salesId: { [id: string]: SalesDto } = {};
  quantitativeBaseOrderCacheVO: SalesDataCacheVO = new SalesDataCacheVO();
  originalValueQuantitativeBaseOrderCacheVO: SalesDataCacheVO = new SalesDataCacheVO();
  public totalRevenue: number = 0;
  public totalTaxes: number = 0;
  public totalSourceDetailsCost: number = 0;
  public numberOfSoldArticles: number = 0;

  public getByIndex(index: number): SalesDto {
    return this.sales[index];
  }

  public removeElementById(id: string): boolean {
    let index = this.sales.findIndex((element) => element.id === id);
    if (index > -1) {
      this.sales.splice(index, 1);
      delete this.salesId[id];
      return true;
    }
    return false;
  }

  public removeElementByIndex(index: number): void {
    let id = this.sales[index].id;
    this.sales.splice(index, 1);
    delete this.salesId[id];
  }


  public swapElements(removeElement: SalesDto, insertElement: SalesDto, index: number): void {
    if (index > -1) {
      this.sales.splice(index, 1, insertElement);
      this.salesId[removeElement.id] = insertElement;
    }
  }


  public setBaseOrderElements(baseOrderElements: SalesDto[]) {
    this.sales = baseOrderElements;
    this.salesId = SalesWrapper.createLookup(baseOrderElements, (element) => element.id);
  }

  public append(baseOrderElement: SalesDto) {
    this.sales.push(baseOrderElement);
    this.salesId[baseOrderElement.id] = baseOrderElement;
  }


  public getBaseOrderElements(): SalesDto[] {
    return this.sales;
  }

  public length(): number {
    return this.sales.length;
  }

  private static createLookup(baseOrderElements: SalesDto[], keyFn: (element: SalesDto) => string): {
    [id: string]: SalesDto
  } {
    let lookup: { [id: string]: SalesDto } = {};
    for (let element of baseOrderElements) {
      lookup[keyFn(element)] = element;
    }
    return lookup;
  }

  public clear() {
    this.sales = [];
    this.salesId = {};
  }

  public generateOriginalValueQuantitativeBaseOrderCacheVO(keys: (keyof SalesDto)[]): void {
    this.originalValueQuantitativeBaseOrderCacheVO.generateCache(this.sales, keys, SalesUtils.getRevenue);
  }

  public generateQuantitativeBaseOrderCacheVO(keys: (keyof SalesDto)[], valueFn: (sale: SalesDto) => number): void {
    this.quantitativeBaseOrderCacheVO.generateCache(this.sales, keys, valueFn);
  }

  public generateTotalRevenue(valueFn: (sale: SalesDto) => number): void {
    this.totalRevenue = 0;
    for (let baseOrderElement of this.sales) {
      this.totalRevenue += valueFn(baseOrderElement);
    }
  }

  generateTotalTaxes(valueFn: (sale: SalesDto) => number, linkedDtoRepository: LinkedDtoRepository<any>): number {
    this.totalTaxes = 0;
    for (let baseOrderElement of this.sales) {
      this.totalTaxes += valueFn(baseOrderElement) - baseOrderElement.revenueAfterTax;
    }
    return this.totalTaxes;
  }

  generateTotalSourceDetailsCost(valueFn: (sale: SalesDto) => number): number {
    this.totalSourceDetailsCost = 0;
    for (let baseOrderElement of this.sales) {
      this.totalSourceDetailsCost += valueFn(baseOrderElement);
    }
    return this.totalSourceDetailsCost;
  }

  generateNumberOfSoldArticles(): number {
    this.numberOfSoldArticles = 0;
    for (let baseOrderElement of this.sales) {
      this.numberOfSoldArticles += baseOrderElement.quantity;
    }
    return this.numberOfSoldArticles;
  }

}
